import { render, staticRenderFns } from "./PageFromStorage.vue?vue&type=template&id=76d376c9&"
import script from "./PageFromStorage.vue?vue&type=script&lang=js&"
export * from "./PageFromStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports